<template>
  <el-dialog
    :visible.sync="ifShow"
    :close-on-click-modal="false"
    :show-close="false"
    width="500px"
    class="system_updating_dialog"
    center
  >
    <div class slot="title">
      <span class="header_title">系统通知</span>
    </div>
    <div class="updating_dia_main">
      <p class="content_title">各位讲师和培训负责人：</p>
      <div class="cont_wrpa">请务必提醒参加培训的学员在日常的培训中使用培训管理系统，参加培训的学员如果没有激活个人帐户完善信息，讲师将无法录入该学员的考试成绩。</div>
      <!-- <p><b>优化功能：</b> <br>1. 密码输入框中提示出需要填写密码格式</p> -->
      <!-- <p><b>新增功能：</b> <br> 1. 未完善信息的学员无法填写成绩</p> -->
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="closeDia">我知道了</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "UpdateDia",
  props: {
    ifShow: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {
    closeDia() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="stylus" scoped>
.system_updating_dialog {
  .header_title {
    color #333
    font-size: 21px;
    font-weight: 700;
  }
  .updating_dia_main {
    font-size: 16px;
    // text-align: center;
    line-height: 1.7;
    .content_title {
      font-size: 18px;
      display block
      font-weight 600
      margin-bottom 10px;
    }
    .cont_wrpa {
      display block
      text-indent 2em
    }
  }
}
</style>

